/**
 * Iconos del feature "Escuchar" (Fase 19.D), portados 1:1 de
 * `claude-design/orborix-speak/v12/project/listen-screens.jsx` (set `LI*`).
 * SVG inline, `currentColor` — el color lo da la clase del contenedor.
 */

interface IconProps {
  size?: number;
}

export const LIPlay = ({ size = 18 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden>
    <path d="M7 4 L 19 12 L 7 20 Z" />
  </svg>
);

export const LIPause = ({ size = 18 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden>
    <rect x="6" y="4" width="4.5" height="16" rx="1.4" />
    <rect x="13.5" y="4" width="4.5" height="16" rx="1.4" />
  </svg>
);

/** Candado del capítulo bloqueado (Fase 22) — acompaña al badge de precio. */
export const LILock = ({ size = 10 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <rect x="5" y="11" width="14" height="9" rx="2.2" />
    <path d="M8 11 V8 a4 4 0 0 1 8 0 v3" />
  </svg>
);

export const LIBack = ({ size = 20 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M15 6 L 9 12 L 15 18" />
  </svg>
);

export const LIPrevTrack = ({ size = 22 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden>
    <rect x="5" y="5" width="2.6" height="14" rx="1.1" />
    <path d="M20 5 L 9 12 L 20 19 Z" />
  </svg>
);

export const LINextTrack = ({ size = 22 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden>
    <rect x="16.4" y="5" width="2.6" height="14" rx="1.1" />
    <path d="M4 5 L 15 12 L 4 19 Z" />
  </svg>
);

export const LIMoon = ({ size = 16 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M20 13 A 8 8 0 1 1 11 4 a 6 6 0 0 0 9 9 Z" />
  </svg>
);

/** Repeat / continuar (dos flechas en bucle) — botón "Reproducción" del dock. */
export const LIRepeat = ({ size = 16 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M17 2 l 4 4 l -4 4" />
    <path d="M3 11 V 9 a 4 4 0 0 1 4 -4 h 14" />
    <path d="M7 22 l -4 -4 l 4 -4" />
    <path d="M21 13 v 2 a 4 4 0 0 1 -4 4 H 3" />
  </svg>
);

export const LIChevUp = ({ size = 18 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M6 15 L 12 9 L 18 15" />
  </svg>
);

export const LIChevDown = ({ size = 22 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M6 9 L 12 15 L 18 9" />
  </svg>
);

export const LIChevR = ({ size = 16 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M9 6 L 15 12 L 9 18" />
  </svg>
);

export const LIBack15 = ({ size = 26 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M11 5 L 7 9 L 11 13" />
    <path d="M7 9 H 14 a 6 6 0 1 1 -6 6" />
  </svg>
);

export const LIFwd15 = ({ size = 26 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M13 5 L 17 9 L 13 13" />
    <path d="M17 9 H 10 a 6 6 0 1 0 6 6" />
  </svg>
);

export const LIChat = ({ size = 20 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" aria-hidden>
    <path d="M21 12 a 9 9 0 0 1 -13 8 L 3 21 L 4 17 A 9 9 0 1 1 21 12 Z" />
  </svg>
);

export const LIExpand = ({ size = 16 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M8 14 L 4 18 M4 18 V 14 M4 18 H 8" />
    <path d="M16 10 L 20 6 M20 6 V 10 M20 6 H 16" />
  </svg>
);

export const LIText = ({ size = 15 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M4 7 H 20 M4 12 H 20 M4 17 H 14" />
  </svg>
);

export const LICheck = ({ size = 16 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M5 12.5 L 10 17 L 19 7" />
  </svg>
);

export const LIVoice = ({ size = 15 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M5 9 V 15 M9 5 V 19 M13 8 V 16 M17 4 V 20 M21 10 V 14" />
  </svg>
);

export const LIGlobe = ({ size = 15 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12 H 21 M12 3 c 3 3 3 15 0 18 M12 3 c -3 3 -3 15 0 18" />
  </svg>
);

/** Aviso de fallo (la línea "sonando" cuando el capítulo no cargó). */
export const LIAlert = ({ size = 14 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 4 L 21 19 H 3 Z" />
    <path d="M12 10 v4 M12 17 h.01" />
  </svg>
);

export const LIX = ({ size = 16 }: IconProps) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M6 6 L 18 18 M18 6 L 6 18" />
  </svg>
);
